import { Outlet } from "react-router-dom";
import './Main.scss'

const Main = () => {
  return (
    <main className={'mdl-main'}>
      <Outlet/>
    </main>
  )
}

export default Main;